import React, { FC, useRef, useState, useLayoutEffect } from 'react'
import { observer } from 'mobx-react'
import { IonInput } from '@ionic/react'
import mktController from 'controllers/mktController'
import markerImg from '@img/mapMarker.png'
import { debounce } from '@dt/fe-utils/dist/lodash'
import Empty from './empty'
import './map.scss'

// interface
interface IProps {
  // 地图中心点
  center?: {
    lat: number;
    lng: number;
  };
  // 当前选中的目标
  activeMarker: string;
  // 门店信息
  stores: IViewStore[];
  onPointClick?(store: IViewStore): void;
  onSelectAddress?: (info: any) => void;
  onError?: (error: any) => void;
}

let map: any
let marker: any
let placeService: any
const GoogleMap: FC<IProps> = (props: IProps) => {
  const { center, onError, onSelectAddress } = props
  const googleRef: any = useRef<any>(null)
  const inputRef: any = useRef<any>(null)
  const [isDraging, setIsDraging] = useState<boolean>(false)
  const [isSearch, setIsSearch] = useState<boolean>(false)
  const [searchEmpty, setSearchEmpty] = useState<boolean>(false)
  const [searchArr, setSearchArr] = useState<any[]>([])
  const [recomArr, setRecomArr] = useState<any[]>([])

  const searchLocal = debounce((value: string) => {
    if (placeService) {
      setSearchEmpty(false)
      const request = {
        query: value,
      }
      placeService.textSearch(
        request,
        (
          results: any[] | null,
          status: any
        ) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            setSearchArr(results)
            !results.length && !!value && setSearchEmpty(true)
          } else {
            setSearchArr([])
            !!value && setSearchEmpty(true)
          }
        }
      )
    }
  }, 300)

  const getNearBy = (pt: any) => {
    if (placeService) {
      const request = {
        location: pt,
        type: 'point_of_interest',
        rankBy: google.maps.places.RankBy.DISTANCE
      }
      placeService.nearbySearch(
        request,
        (
          results: any[] | null,
          status: any
        ) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            results.map((item: any) => {
              item.formatted_address = item.vicinity
              return item
            })
            setRecomArr(results)
          }
        }
      )
    }
    mapToCenter(pt)
  }

  const mapToCenter = (point: any) => {
    map.setCenter(point)
  }

  const getStateCountyCity = (addressComponents: any[]) => {
    const findPlace = (
      type:
      | 'administrative_area_level_1'
      | 'administrative_area_level_2'
      | 'locality'
    ) => {
      const place = addressComponents.find((item) => {
        return item.types.includes(type)
      })
      if (place) {
        return {
          longName: place.long_name.replace(' County', ''),
          shortName: place.short_name.replace(' County', ''),
        }
      }
      return {
        longName: '',
        shortName: '',
      }
    }
    return {
      state: findPlace('administrative_area_level_1'),
      county: findPlace('administrative_area_level_2'),
      city: findPlace('locality'),
    }
  }

  const sureSelectAddres = (item: any) => {
    placeService.getDetails({
      placeId: item.place_id
    }, (res: any) => {
      const cityInfo: any = getStateCountyCity(res.address_components)
      onSelectAddress && onSelectAddress({
        ...item,
        cityInfo,
      })
    })
  }
  const handleError = (info) => {
    setIsSearch(true)
    onError && onError(info)
  }

  const initBMap = (centerInfo: any) => {
    map = new google.maps.Map(googleRef.current, {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 18,
      keyboardShortcuts: false,
      mapTypeControl: false,
      fullscreenControl: false,
      gestureHandling: 'greedy'
    })
    placeService = new google.maps.places.PlacesService(map)
    const myIocn = {
      url: markerImg,
      size: new google.maps.Size(20, 32),
      anchor: new google.maps.Point(10, 20),
      scaledSize: new google.maps.Size(20, 31)
    }
    if (centerInfo) {
      marker = new google.maps.Marker({
        position: centerInfo,
        icon: myIocn
      })
      marker.setMap(map)
      setTimeout(() => {
        getNearBy(centerInfo)
      }, 300)
    } else {
      mktController.openLBS().then((location: any) => {
        const pos = {
          lat: location.latitude,
          lng: location.longitude,
        }
        marker = new google.maps.Marker({
          position: pos,
          icon: myIocn
        })
        marker.setMap(map)
        getNearBy(pos)
      }, (error: any) => {
        handleError(error)
      })
    }

    map.addListener('dragstart', (e: any) => {
      if (marker) marker.setMap(null)
      setIsDraging(true)
    })
    map.addListener('dragend', (e: any) => {
      const center = map.getCenter()
      const point: any = {
        lat: center.lat(),
        lng: center.lng(),
      }
      setIsDraging(false)
      marker = new google.maps.Marker({
        position: point,
        icon: myIocn
      })
      getNearBy(point)
      marker.setMap(map)
    })
  }

  useLayoutEffect(() => {
    if (!window.initGoogleMapSDKStatus) return
    initBMap(center)
  }, [center])
  return (
    <div
      className='location-map-area'
    >
      <div className='local-search'>
        <div className='search-input'>
          <div className='input-right'>
            <IonInput
              ref={inputRef}
              placeholder={i18n.t('location.enterShippingAddressUs')} onFocus={() => setIsSearch(true)} onIonChange={(e: any) => searchLocal(e.detail.value)} onIonBlur={(e: any) => {
                if (!e.detail.value && searchArr.length === 0) {
                  setIsSearch(false)
                }
              }}
              clearInput
            />
          </div>
        </div>
      </div>
      <div className='map-show-area'>
        {
          window.initGoogleMapSDKStatus === 'success'
            ? (
              <>
                <div className='baidu-map-show' ref={googleRef}></div>
                {isDraging &&
                  <div className='baidu-map-marker'>
                    <img src={markerImg} alt='' />
                  </div>}
              </>
            ) : (
              <div className='map-error'>
                <i className='iconfont icon-togo0'></i>
                <span>{i18n.t('common.page404')}</span>
              </div>
            )
        }
      </div>
      <div className='local-recom'>
        {
          recomArr.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className='search-item'
                data-cypid={`googleMapLocalSearchItem_${index}`}
                onClick={() => {
                  sureSelectAddres(item)
                }}
              >
                <div className='left'>
                  <i className='iconfont icon-togo0' style={{ color: index === 0 ? '#E50E2B' : '#c6c6c6' }}></i>
                </div>
                <div className='right'>
                  <div className='title'>{item.name}</div>
                  <div className='des'>{item.formatted_address || ''}</div>
                </div>
              </div>
            )
          })
        }
      </div>
      {
        isSearch && (
          <div
            className='search-area'
          >
            {
              searchArr.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className='search-item'
                    data-cypid={`googleMapAreaSearchItem_${index}`}
                    onClick={(e: any) => {
                      e.stopPropagation()
                      sureSelectAddres(item)
                    }}
                  >
                    <div className='title'>{item.name}</div>
                    <div className='des'>{item.formatted_address}</div>
                  </div>
                )
              })
            }
            {
              searchEmpty && (
                <Empty msg={i18n.t('location.enterShippingAddressUs')} height='55vh' />
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default observer(GoogleMap)
